import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  fontWeight,
  screen,
  spacing
} from '../../../theme';
import { Heading2 } from '../../shared/Typography';

export const StyledBenefits = styled.div`
  background-color: ${color('white')};
  padding-bottom: ${spacing('xl4')};
  padding-top: ${spacing('xl4')};
  text-align: center;

  > div {
    max-width: ${container('lg')};
    margin: auto;
    margin-top: ${spacing('lg')};
    padding-top: ${spacing('md')};
    padding-left: ${spacing('md')};
    padding-right: ${spacing('md')};

    @media (min-width: ${screen('md')}) {
      display: flex;
      flex-direction: row-reverse;
      gap: ${spacing('xl')};
    }
  }

  ${Heading2} {
    margin-bottom: ${spacing('xl3')};
  }
`;

export const StyledBenefitsList = styled.div`
  max-width: ${container('lg')};
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${spacing('xl3')};
  margin-bottom: ${spacing('xl')};
`;

export const StyledItem = styled.div`
  max-width: 14rem;

  p {
    margin-top: 0;
    margin-bottom: 0;
    font-size: ${fontSize('sm')};
  }
`;

export const StyledItemIcon = styled.img`
  display: block;
  width: 4.68rem;
  max-height: 4.68rem;
  margin-bottom: ${spacing('md')};
  margin-left: auto;
  margin-right: auto;
`;

export const StyledItemTitle = styled.p`
  && {
    font-weight: ${fontWeight('black')};
    text-transform: uppercase;
    margin-bottom: ${spacing('xs2')};
  }
`;
